import { useState } from "react";
import styles from "./styles/EmptyQuestions.module.css";
import { Button } from "antd";

const EmptyQuestions = ({ onCreateQuestion }) => {
  const [loading, setLoading] = useState(false);

  return (
    <div className={styles["empty-question"]}>
      <h2>No hay preguntas</h2>
      <p>Comienza creando la primera pregunta para esta pagina</p>
      <Button
        loading={loading}
        onClick={async () => {
          setLoading(true);
          await onCreateQuestion?.();
          setLoading(false);
        }}
        type="primary"
      >
        Crear pregunta
      </Button>
    </div>
  );
};

export default EmptyQuestions;
